import { apiClient } from './api'
import type { ApiResponse } from '@/types/common'
import type { Module, CreateModuleDTO, UpdateModuleDTO } from '@/types/module'

export const moduleService = {
  getByCourseId: async (courseId: string): Promise<ApiResponse<Module[]>> => {
    return apiClient.get<Module[]>(`/courses/${courseId}/modules`)
  },

  getById: async (id: string): Promise<ApiResponse<Module>> => {
    return apiClient.get<Module>(`/modules/${id}`)
  },

  getAll: async (): Promise<ApiResponse<Module[]>> => {
    return apiClient.get<Module[]>('/modules')
  },

  create: async (data: CreateModuleDTO): Promise<ApiResponse<Module>> => {
    return apiClient.post<Module>(`/courses/${data.courseId}/modules`, data)
  },

  update: async (id: string, data: UpdateModuleDTO): Promise<ApiResponse<Module>> => {
    return apiClient.put<Module>(`/modules/${id}`, data)
  },

  delete: async (id: string): Promise<ApiResponse<void>> => {
    return apiClient.delete<void>(`/modules/${id}`)
  },

  publish: async (id: string): Promise<ApiResponse<Module>> => {
    return apiClient.post<Module>(`/modules/${id}/publish`)
  },

  reorder: async (courseId: string, moduleIds: string[]): Promise<ApiResponse<void>> => {
    return apiClient.post<void>(`/courses/${courseId}/modules/reorder`, { moduleIds })
  },
}
